// removed by extract-text-webpack-plugin
module.exports = {"ddgNumber":"styles__ddgNumber___2sSpY","selectNumber":"styles__selectNumber___PwZn6","hoursBalance":"styles__hoursBalance___3DGkN","details":"styles__details___24ij-"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/Manager/styles.css
// module id = 2853
// module chunks = 0